<template>
  <div id="sellorder">
     <div class="disflex">
       <!-- <div>
          <el-input v-model="searchKey" placeholder="请输入合同号" @change="handleChangeOrderStatus"></el-input>
      </div> -->
      <el-select v-model="currentStatus" placeholder="请选择" @change="handleChangeOrderStatus" clearable>
        <el-option
          v-for="n in statuslist"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select>
      <!-- <el-select v-model="queryBycompanyStatus" placeholder="请选择" @change="handleChangeCompanyStatus">
        <el-option
          v-for="n in companyStatus"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select> -->
    </div>
    <div class="comond_btn" v-if="(roleCode === 'administrator' || roleCode === 'admin')">
      <el-button  @click="handleEdit(0, null)" >创建订单</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">

        <el-table-column
          prop="contractNumber"
          label="销售合同号"
          width="">
        </el-table-column>

        <el-table-column
          prop="goodsName"
          label="商品名称">
        </el-table-column>
        
        <el-table-column
          prop="model"
          label="型号">
        </el-table-column>

        <!-- <el-table-column
          prop="packWeight"
          label="规格">
        </el-table-column> -->

        <el-table-column
          label="规格">
          <template slot-scope="scope">
             <div>{{ scope.row.packWeight? scope.row.packWeight: '' + scope.row.goodsSpec}}</div>
           </template>
        </el-table-column>

        <el-table-column
          prop="unitCost"
          label="销售单价">
        </el-table-column>

        <el-table-column
          prop="currencyName"
          label="币种">
        </el-table-column>

        <el-table-column
          prop="companyName"
          label="采购商">
        </el-table-column>

        <el-table-column
          prop="salesQuantity"
          label="销售数量净重(公斤)">
        </el-table-column>

        <el-table-column
          label="要求到货时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.arrivalTimeStart) }} 至 {{ formatime(scope.row.arrivalTimeEnd) }}</div>
           </template>
        </el-table-column>

        <el-table-column
          label="实际到货时间">
          <template slot-scope="scope">
             <div>{{ scope.row.signTime? formatime(scope.row.signTime): ' ' }}</div>
           </template>
        </el-table-column>

        <el-table-column
          label="状态">
          <template slot-scope="scope">
             <div>{{ resetstatus(scope.row.orderStatus) }}</div>
           </template>
        </el-table-column>
        


        <el-table-column
          width="240"
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="info"
              @click="handleEdit(2, scope.row)">查看</el-button>
              <el-button
              size="mini"
              type="primary"
              v-if="scope.row.orderStatus === 1 && (roleCode === 'administrator' || roleCode === 'admin')"
              @click="handleEdit(1, scope.row)">编辑</el-button>

              <el-button
              size="mini"
              type="error"
              v-if="scope.row.orderStatus === 2 && (roleCode === 'administrator' || roleCode === 'admin')"
              @click="handleEdit(3, scope.row)">审核</el-button>

              <el-button
              size="mini"
              type="success"
              v-if="scope.row.orderStatus === 4 && (roleCode === 'administrator' || roleCode === 'admin')"
              @click="handleEdit(4, scope.row)">发货</el-button>

              <el-button
              size="mini"
              type="warning"
              v-if="scope.row.orderStatus === 5 && (roleCode === 'administrator' || roleCode === 'admin')"
              @click="handleEdit(5, scope.row)">确认收货</el-button>

            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.orderStatus < 4 && (roleCode === 'administrator' || roleCode === 'admin')"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total,prev, pager, next"
          @current-change="handelCurrentChange"
          :current-page="currentpageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="50%"
        center>

        <el-form :model="form" :rules="rules">
          
          <el-form-item label="销售合同号" class="dbgroup" :label-width="formLabelWidth" prop="contractNumber">
            <el-input v-model="form.contractNumber" v-if="isshow === false">
              <el-button slot="append" class="btnin" @click="autogeneration">自动生成</el-button>
            </el-input>
            <div v-if="isshow === true">{{ form.contractNumber }}</div>
          </el-form-item>
         
          <el-form-item label="商品名称" :label-width="formLabelWidth">
             <el-select v-model="form.goodsId" placeholder="请选择" @change="(value) => {return handelchangegoods(value)}" v-if="isshow === false">
              <el-option
                v-for="item in goodsList"
                :key="item.key"
                :label="item.cnName? item.cnName: item.enName"
                :value="item.id">
                <span style="float: left">{{ item.cnName !== undefined? item.cnName: '' + ' /' }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{item.enName  + ' : ' +item.model }}</span>
              </el-option>
            </el-select>
            <div v-if="isshow === true">{{ form.goodsName }}</div>
          </el-form-item>

          <el-form-item label="型号" :label-width="formLabelWidth" prop="model">
            <el-input v-model="form.model" :disabled="true" v-if="isshow === false"></el-input>
            <div v-if="isshow === true">{{ form.model }}</div>
          </el-form-item>

          <el-form-item label="规格"  class="dbgroup" :label-width="formLabelWidth" prop="packWeight">
            <el-input v-model="form.packWeight"  :disabled="true" v-if="isshow === false">
              <el-button slot="append">{{ form.goodsSpec }}</el-button>
            </el-input>
            <div v-if="isshow === true">{{ form.packWeight }}{{ form.goodsSpec }}</div>
          </el-form-item>

          <el-form-item label="采购商" :label-width="formLabelWidth" prop="supplierId">
            <el-select v-model="form.companyId" placeholder="请选择" :disabled="true" @change="(value) => { return handelchangecompany(value, 1)}" v-if="isshow === false">
               <el-option
                v-for="item in companylist"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
            <div v-if="isshow === true">{{ form.companyName }}</div>
          </el-form-item>

           <el-form-item label="联系人" :label-width="formLabelWidth">
            <!-- <el-select v-model="form.contactsId" placeholder="请选择" @change="handleChangeContact" v-if="isshow === false"> -->
            <el-select v-model="form.contactsId" placeholder="请选择" @change="handleChangeContact" v-if="isshow === false">
               <el-option
                v-for="item in contactList"
                :key="item.key"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <!-- <div v-if="isshow === true">{{ form.contact.name }}</div> -->
            <div v-if="isshow === true">{{ form.placeContact.name }}</div>
          </el-form-item>

          <el-form-item label="电话" :label-width="formLabelWidth">
            <el-input v-model="contactDetail.phone" :disabled="true" v-if="isshow === false"></el-input>
            <div v-if="isshow === true">{{ form.placeContact.phone }}</div>
          </el-form-item>

          <el-form-item label="微信" :label-width="formLabelWidth">
            <el-input v-model="contactDetail.weChat" :disabled="true" v-if="isshow === false"></el-input>
            <div v-if="isshow === true">{{ form.placeContact.weChat }}</div>
          </el-form-item>

          <el-form-item label="邮箱" :label-width="formLabelWidth">
            <el-input v-model="contactDetail.email" :disabled="true" v-if="isshow === false"></el-input>
            <div v-if="isshow === true">{{ form.placeContact.email }}</div>
          </el-form-item>

          <el-form-item label="发货数量(净重)" class="dbgroup" :label-width="formLabelWidth">
            <el-input v-model="form.salesQuantity" @change="countPrice">
               <el-button slot="append">公斤</el-button>
            </el-input>
            <div v-if="isshow === true">{{ form.salesQuantity }}公斤</div>
          </el-form-item>

           <el-form-item label="发货数量(毛重)" class="dbgroup" :label-width="formLabelWidth">
            <el-input v-model="form.roughWeight" v-if="isshow === false" @change="countPrice">
               <el-button slot="append">公斤</el-button>
            </el-input>
            <div v-if="isshow === true">{{ form.roughWeight }}公斤</div>
          </el-form-item>

          <el-form-item label="销售单价" class="dbgroup" :label-width="formLabelWidth">
            <el-input v-model="form.unitCost" v-if="isshow === false" @change="countPrice">
               <el-select slot="append" v-model="form.currencyCode" placeholder="请选择" @visible-change="handelchangecurrency">
               <el-option
                v-for="item in currencyList"
                :key="item.key"
                :label="item.currency"
                :value="item.code">
              </el-option>
            </el-select>
            </el-input>
            <div v-if="isshow === true">{{ form.unitCost }}{{ form.currencyName }}</div>
          </el-form-item>

          <el-form-item label="销售总价" class="dbgroup" :label-width="formLabelWidth">
            <div  v-if="isshow === false" >{{ (form.salesQuantity * form.unitCost).toFixed(2) }}</div>
            <!-- <el-input v-model="totalprice" v-if="isshow === false" :disabled="true">
               <el-select slot="append" v-model="form.currencyCode" placeholder="请选择" @visible-change="handelchangecurrency">
               <el-option
                v-for="item in currencyList"
                :key="item.key"
                :label="item.currency"
                :value="item.code">
              </el-option>
            </el-select>
            </el-input> -->
            <div v-if="isshow === true">{{ form.salesQuantity * form.unitCost }}{{ form.currencyName }}</div>
          </el-form-item>

          <el-form-item :label="'总价('+form.currencyName+')'" class="dbgroup" :label-width="formLabelWidth" prop="salesQuantity" v-if="sts === 2">
            <div v-if="isshow === true">{{ form.totalPrices }}</div>
          </el-form-item>

          <p class="choosetime">
            <el-form-item label="下单时间" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.placeOrderTime"
                type="date"
                v-if="isshow === false"
                placeholder="下单时间">
              </el-date-picker>
              <div v-if="isshow === true">{{ formatime(form.placeOrderTime) }}</div>
            </el-form-item>
          </p>

          <p class="choosetime">
            <el-form-item label="要求到货时间" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.arrivalTimeStart"
                type="date"
                v-if="isshow === false"
                placeholder="最早供货时间">
              </el-date-picker>
              <div v-if="isshow === true">{{ formatime(form.arrivalTimeStart) }}</div>
              
              <div style="margin: 0 10px"> - </div>
              <el-date-picker
                v-model="form.arrivalTimeEnd"
                type="date"
                v-if="isshow === false"
                placeholder="最晚供货时间">
              </el-date-picker>
              <div v-if="isshow === true">{{ formatime(form.arrivalTimeEnd) }}</div>
            </el-form-item>
          </p>

          <el-form-item label="付款方式" :label-width="formLabelWidth">
            <el-select v-model="form.paymentType" placeholder="请选择" value-key='id' v-if="isshow === false">
               <el-option
                v-for="item in getpaymentTypeList"
                :key="item.key"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <div v-if="isshow === true">{{ paymentType(form.paymentType) }}</div>
          </el-form-item>

          <el-form-item label="销售合同" :label-width="formLabelWidth">
            <div>
              <el-button type="primary" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
            </div>
            <!-- <el-upload
              class="upload-demo"
              :data="qiniu"
              :limit="1"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="salesContractUrl"
              v-if="isshow === false"
              :before-upload="handleBeforeUpload3"
              :on-success="handleOnSuccess3"
              :on-remove="handleOnRemove3"
            >
            <el-button size="small" type="primary">点击上传</el-button>
            </el-upload> -->
          </el-form-item>

          <el-form-item label="库存" v-if="isshow === false && sts !== 1">
            <div>&nbsp;</div>
            <div v-for="n in batchNumberIds" :key="n.key">
              仓库地址: {{ n.locationName }}
              <div v-for="nn in n.contractGoodsVos" :key="nn.key">
                采购合同号: {{ nn.contractNum }}
                <el-checkbox-group 
                  v-model="form.batchNumberIds"
                  @change="handlechangeLotnum"
                  >
                    <el-checkbox v-for="nnn in nn.batchNumberGoods" :key="nnn.key" :label="nnn.id">{{ '批号:' + nnn.lotNum + ' ' +'余量:' + nnn.allowance}}公斤</el-checkbox>
                </el-checkbox-group>

              </div>
            </div>
          </el-form-item>
          <!-- 编辑 -->
          <el-form-item label="库存" v-if="isshow === false && sts === 1">
            <div>&nbsp;</div>
            <div v-for="n in batchNumberIds" :key="n.key">
              仓库地址: {{ n.locationName }}
              <div v-for="nn in n.contractGoodsVos" :key="nn.key">
                采购合同号: {{ nn.contractNum }}
                <el-checkbox-group 
                  v-model="batchNumberIds2"
                  @change="handlechangeLotnum"
                  >
                    <el-checkbox v-for="nnn in nn.batchNumberGoods" :key="nnn.key" :label="nnn.id">{{ '批号:' + nnn.lotNum + ' ' +'余量:' + nnn.allowance}}公斤</el-checkbox>
                </el-checkbox-group>

              </div>
            </div>
          </el-form-item>

          <el-form-item label=""  v-if="(sts === 2 && form.orderStatus > 3) || (roleCode === 'administrator' || roleCode === 'admin') " hidden>
            <div v-for="n in form.orderBatchVos" :key="n.key">
              <div>{{'库位地址: ' + n.locationName }}</div>
              <div v-for="nn in n.batchVos" :key="nn.key">
                <div v-if="(roleCode === 'administrator' || roleCode === 'admin')">{{'采购订单号: ' + nn.purchaseContractNum}}</div>
                <div v-for="nnn in nn.orderDetailsDtos" :key="nnn.key">
                  <div>{{'批号:' + nnn.lotNum }}</div>
                  <div>{{'批号供货量:' + nnn.salesVolume }}公斤</div>
                  <div>{{'coa:'}} <img :src="nnn.coa" style="width:200px;height:200px;"/></div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="原因"  v-if="sts === 3">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="如果不通过请填写原因"
              v-model="reviewOrder.remark">
            </el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button  @click="handlePass(false)" v-if="sts === 3">不通过</el-button>
          <el-button type="primary" @click="handlePass(true)" v-if="sts === 3">通 过</el-button>
          <el-button  @click="centerDialogVisible = false" v-if="sts !== 3">取消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)" v-if="sts !== 3">确 定</el-button>
        </span>
      </el-dialog>

        <!-- 发货 ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！-->
        
      <el-dialog
        :title="title2"
        :visible.sync="centerDialogVisible2"
        width="50%"
        center>
        <el-form :model="form">

          <div class="disflexbtw">
            <el-form-item label="销售合同号" class="disflex">
              <div>{{ form.contractNumber }}</div>
            </el-form-item>
            <el-form-item label="商品名称" class="disflex">
               <div>{{ form.goodsName }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="型号" class="disflex">
              <div>{{ form.model }}</div>
            </el-form-item>
            <el-form-item label="规格" class="disflex">
              <div>{{ form.packWeight + form.goodsSpec }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="客户名称" class="disflex">
             <div>{{ form.companyName }}</div>
            </el-form-item>
            <el-form-item label="要求到货时间" class="disflex">
             <div>{{ formatime(form.arrivalTimeStart)+ ' 至 ' +formatime(form.arrivalTimeStart)  }}</div>
            </el-form-item>
          </div>

          <el-collapse  v-model="activeName">
            <el-collapse-item  name="1">
               <div class="disflexbtw">
                  <el-form-item label="下单联系人" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.name: '无'}}</div>
                  </el-form-item>
                  <el-form-item label="电话" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.phone: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="微信" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.weChat: '无' }}</div>
                  </el-form-item>
                  <el-form-item label="QQ" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.qq: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售单价" class="disflex">
                  <div>{{ form.unitCost + form.currencyName }}</div>
                  </el-form-item>
                  <el-form-item label="下单时间" class="disflex">
                  <div>{{ formatime(form.placeOrderTime) }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="付款方式" class="disflex">
                  <div>{{ paymentType(form.paymentType) }}</div>
                  </el-form-item>
                  <el-form-item label="销售数量(净重)" class="disflex">
                  <div>{{ form.salesQuantity + '公斤' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售合同" class="disflex">
                  <el-button type="primary" size="mini" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
                  </el-form-item>
                  <el-form-item label="销售总价" class="disflex">
                  <div>{{ form.totalPrices + form.currencyName }}</div>
                  </el-form-item>
              </div>

              <div>
                <el-form-item label="销售数量(毛重)" class="disflex">
                  <div>{{ form.roughWeight }}公斤</div>
                </el-form-item>
              </div>

              <div  v-for="n in form.orderBatchVos" :key="n.key">
                <div>
                    <el-form-item label="仓库地址" class="disflex">
                      <div>{{ n.locationName }}</div>
                    </el-form-item>
                </div>

                <div  v-for="nn in n.batchVos" :key="nn.key">
                  <div v-for="nnn in nn.orderDetailsDtos" :key="nnn.key"  class="disflexbtw">
                    <el-form-item label="批号" class="disflex">
                      <div>{{ nnn.lotNum }}</div>
                    </el-form-item>
                    <el-form-item label="数量" class="disflex">
                        <div>{{ nnn.salesVolume }}公斤</div>
                    </el-form-item>
                  </div>
                </div>
              </div>

            </el-collapse-item>
          </el-collapse>

          <div class="disflexbtw">
             <el-form-item label="物流公司" :label-width="formLabelWidth">
              <el-select v-model="form.logisticsCompanyId" placeholder="请选择"  @change="(value) => { return handelchangecompany(value, 6)}">
                <el-option
                  v-for="item in companylist"
                  :key="item.key"
                  :label="item.chineseName?item.chineseName:item.englishName"
                  :value="item.id">
                  <span style="float: left">{{ item.chineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="发货时间" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.deliveryTime"
                type="date"
                placeholder="发货时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="disflexbtw">
             <el-form-item label="物流联系人" :label-width="formLabelWidth">
              <el-select v-model="form.logisticsContactsId" placeholder="请选择">
                <el-option
                  v-for="item in contactList2"
                  :key="item.key"
                  :label="item.name + ' : ' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            
          </div>

          <div class="disflexbtw">
             <el-form-item label="收件地址" :label-width="formLabelWidth" prop="supplierId">
              <el-select v-model="form.consigneeAddressId" placeholder="请选择">
                <el-option
                  v-for="item in Addresslist"
                  :key="item.key"
                  :label="item.address"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="收件联系人" :label-width="formLabelWidth">
              <el-select v-model="form.takeContarctsId" placeholder="请选择">
                <el-option
                  v-for="item in contactList"
                  :key="item.key"
                  :label="item.name + ':' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="物流费用" class="dbgroup disflex" >
              <el-input v-model="form.logisticsFees">
                <el-button slot="append"> ￥</el-button>
              </el-input>
            </el-form-item>

            <el-form-item label="出库照片" :label-width="formLabelWidth">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="shipmentFigureUrl"
                v-if="isshow === false"
                :before-upload="handleBeforeUpload111"
                :on-success="handleOnSuccess111"
                :on-remove="handleOnRemove111"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>

            
          </div>

          <div class="disflexbtw">
            <el-form-item label="发货单" :label-width="formLabelWidth">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="dispatchBillUrl"
                v-if="isshow === false"
                :before-upload="handleBeforeUpload10"
                :on-success="handleOnSuccess10"
                :on-remove="handleOnRemove10"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>

             <el-form-item label="仓库出货情况(excel)" :label-width="formLabelWidth">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="warehouseExcelUrl"
                v-if="isshow === false"
                :before-upload="handleBeforeUpload11"
                :on-success="handleOnSuccess11"
                :on-remove="handleOnRemove11"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </div>

          <div>
            <el-form-item label="备注" class="dbgroup disflex" >
              <el-input v-model="form.remark">
               
              </el-input>
            </el-form-item>
          </div>

          <div>
            <el-form-item label="周六、周日是否出货" class="disflex">
               <el-radio v-model="form.weekendWork" label="1">是</el-radio>
               <el-radio v-model="form.weekendWork" label="0">否</el-radio>
            </el-form-item>
          </div>

          <el-card class="box-card" v-if="form.replenishmentOrderVos">
            <di v-for="n in form.replenishmentOrderVos" :key="n.key">
             <div class="disflexbtw">
                <el-form-item label="补货 销售合同号:" class="disflex">
                  <div>{{ n.contractNumber }}</div>
                </el-form-item>

                <el-form-item label="商品名称:" class="disflex">
                  <div>{{ n.goodsName }}</div>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="型号:" class="disflex">
                  <div>{{ n.mode }}</div>
                </el-form-item>

                <el-form-item label="总数量:" class="disflex">
                  <div>{{ n.totalWeight }}</div>
                </el-form-item>
              </div>

              <div v-for="nn in n.batchQuantity" :key="nn.key">
                <div v-for="nnn in nn" :key="nnn.key" class="disflexbtw">
                  <el-form-item label="批号" class="disflex">
                      <div>{{ splitStrkey(nnn) }}</div>
                  </el-form-item>
                  <el-form-item label="数量" class="disflex">
                      <div>{{ splitStrVal(nnn) }}公斤</div>
                  </el-form-item>
                </div>
              </div>
            </di>
          </el-card>

        </el-form>
         <span slot="footer" class="dialog-footer">
          <el-button  @click="centerDialogVisible2 = false">取消</el-button>
          <el-button type="primary" @click="handlesend()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 发货结束 -->

       <!-- 确认收货 ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！-->
        
      <el-dialog
        :title="title2"
        :visible.sync="centerDialogVisible4"
        width="50%"
        center>
        <el-form :model="form">

          <div class="disflexbtw">
            <el-form-item label="销售合同号" class="disflex">
              <div>{{ form.contractNumber }}</div>
            </el-form-item>
            <el-form-item label="商品名称" class="disflex">
               <div>{{ form.goodsName }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="型号" class="disflex">
              <div>{{ form.model }}</div>
            </el-form-item>
            <el-form-item label="规格" class="disflex">
              <div>{{ form.packWeight + form.goodsSpec }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="客户名称" class="disflex">
             <div>{{ form.companyName }}</div>
            </el-form-item>
            <el-form-item label="要求到货时间" class="disflex">
             <div>{{ formatime(form.arrivalTimeStart)+ ' 至 ' +formatime(form.arrivalTimeStart)  }}</div>
            </el-form-item>
          </div>

          <el-collapse  v-model="activeName">
            <el-collapse-item  name="1">
               <div class="disflexbtw">
                  <el-form-item label="下单联系人" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.name: '无'}}</div>
                  </el-form-item>
                  <el-form-item label="电话" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.phone: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="微信" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.weChat: '无' }}</div>
                  </el-form-item>
                  <el-form-item label="QQ" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.qq: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售单价" class="disflex">
                  <div>{{ form.unitCost + form.currencyName }}</div>
                  </el-form-item>
                  <el-form-item label="下单时间" class="disflex">
                  <div>{{ formatime(form.placeOrderTime) }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="付款方式" class="disflex">
                  <div>{{ paymentType(form.paymentType) }}</div>
                  </el-form-item>
                  <el-form-item label="销售数量(净重)" class="disflex">
                  <div>{{ form.salesQuantity + '公斤' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售合同" class="disflex">
                  <el-button type="primary" size="mini" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
                  </el-form-item>
                  <el-form-item label="销售总价" class="disflex">
                  <div>{{ form.totalPrices + form.currencyName }}</div>
                  </el-form-item>
              </div>

              <div>
                <el-form-item label="销售数量(毛重)" class="disflex">
                  <div>{{ form.roughWeight }}公斤</div>
                </el-form-item>
              </div>

              <div  v-for="n in form.orderBatchVos" :key="n.key">
                <div>
                    <el-form-item label="仓库地址" class="disflex">
                      <div>{{ n.locationName }}</div>
                    </el-form-item>
                </div>

                <div  v-for="nn in n.batchVos" :key="nn.key">
                  <div v-for="nnn in nn.orderDetailsDtos" :key="nnn.key"  class="disflexbtw">
                    <el-form-item label="批号" class="disflex">
                      <div>{{ nnn.lotNum }}</div>
                    </el-form-item>
                    <el-form-item label="数量" class="disflex">
                        <div>{{ nnn.salesVolume }}公斤</div>
                    </el-form-item>
                  </div>
                </div>
              </div>

            </el-collapse-item>
          </el-collapse>

 

          <div class="disflexbtw">
             <el-form-item label="物流公司" :label-width="formLabelWidth">
              <div>{{ logisticsCompany.chineseName }}</div>
            </el-form-item>

            <el-form-item label="发货时间" :label-width="formLabelWidth">
              <div>{{ takeContact.deliveryTime }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
             <el-form-item label="物流联系人" :label-width="formLabelWidth">
              <div> {{ logisticsContact.name }}</div>
            </el-form-item>

            
          </div>

          <div class="disflexbtw">
             <el-form-item label="收件地址" :label-width="formLabelWidth">
              <div> {{ takeContact.consigneeAddress? takeContact.consigneeAddress: ''  }}</div>
            </el-form-item>

            <el-form-item label="收件联系人" :label-width="formLabelWidth">
              <div> {{ takeContact.name }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="物流费用" class="dbgroup disflex" >
              <div> {{ takeContact.logisticsFees }}</div>
            </el-form-item>

             <el-form-item label="出库照片" :label-width="formLabelWidth">
              <el-button type="primary" size="mini" @click="downloadpdf(takeContact.shipmentFigureUrl)" >预览下载</el-button>
            </el-form-item>


          </div>

          <div class="disflexbtw">
            <el-form-item label="发货单" :label-width="formLabelWidth">
              <el-button type="primary" size="mini" @click="downloadpdf(takeContact.dispatchBillUrl)" >预览下载</el-button>
            </el-form-item>

             <el-form-item label="仓库出货情况(excel)" :label-width="formLabelWidth">
              <el-button type="primary" size="mini" @click="downloadpdf(takeContact.warehouseExcelUrl)" >预览下载</el-button>
            </el-form-item>
            
          </div>

          <div>
            <el-form-item label="周六、周日是否出货" class="disflex">
               <div> {{ takeContact.weekendWork === '1'? '是': '否'  }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="收货日期" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.signTime"
                type="date"
                placeholder="收货日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="*签收单" :label-width="formLabelWidth">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="receiptormUrl"
                :before-upload="handleBeforeUpload21"
                :on-success="handleOnSuccess21"
                :on-remove="handleOnRemove21"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="*客户实收" class="dbgroup disflex" >
              <el-input v-model="form.realQuantity" @change="handleChangePrice">
                <el-button slot="append">公斤</el-button>
              </el-input>
            </el-form-item>

            <el-form-item label="*签收照片" :label-width="formLabelWidth">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="receivingFigureUrl"
                :before-upload="handleBeforeUpload22"
                :on-success="handleOnSuccess22"
                :on-remove="handleOnRemove22"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </div>

          <div v-if="ishowreplenishment === true">
            <el-form-item label="处理方式" class="disflex">
               <el-radio v-model="form.isReplenishment" label="1" @change="handleChangeshopping">补货</el-radio>
               <el-radio v-model="form.isReplenishment" label="0" @change="handleChangeshopping">不补货</el-radio>
            </el-form-item>

            <div v-if="ishowreplenishment2 === false">
              <el-form-item label="重新上传的销售合同PDF文件">
                <el-upload
                  class="upload-demo"
                  :data="qiniu"
                  :limit="1"
                  action="https://upload.qiniup.com"
                  :show-file-list="true"
                  :multiple="false"
                  :file-list="salesContractUrl"
                  :before-upload="handleBeforeUpload3"
                  :on-success="handleOnSuccess3"
                  :on-remove="handleOnRemove3"
                >
                <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>
          </div>
      
          <el-card class="box-card" v-if="form.replenishmentOrderVos">
            <div v-for="(n, index) in form.replenishmentOrderVos" :key="n.key">
             <div class="disflexbtw">
                <el-form-item label="补货 销售合同号:" class="disflex">
                  <div>{{ n.contractNumber }}</div>
                </el-form-item>

                <el-form-item label="商品名称:" class="disflex">
                  <div>{{ n.goodsName }}</div>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="型号:" class="disflex">
                  <div>{{ n.mode }}</div>
                </el-form-item>

                <el-form-item label="总数量:" class="disflex">
                  <div>{{ n.totalWeight }}</div>
                </el-form-item>
              </div>

              <div v-for="nn in n.batchQuantity" :key="nn.key">
                <div v-for="nnn in nn" :key="nnn.key" class="disflexbtw">
                  <el-form-item label="批号" class="disflex">
                      <div>{{ splitStrkey(nnn) }}</div>
                  </el-form-item>
                  <el-form-item label="数量" class="disflex">
                      <div>{{ splitStrVal(nnn) }}公斤</div>
                  </el-form-item>
                </div>
              </div>
              

              <div class="disflexbtw">
                <el-form-item label="客户实收" class="dbgroup disflex" >
                  <el-input v-model="damageVoList.realQuantity" @change="(value) => {return handleChangePrice11(value, index)}">
                    <el-button slot="append">公斤</el-button>
                  </el-input>
                </el-form-item>
              </div>
          
            <div v-if="ishowreplenishment11 === true">
              <el-form-item label="处理方式" class="disflex">
                <el-radio v-model="damageVoList.isReplenishment" label="1" @change="handleChangeshopping11">补货</el-radio>
                <el-radio v-model="damageVoList.isReplenishment" label="0" @change="handleChangeshopping11">不补货</el-radio>
              </el-form-item>

            <div v-if="ishowreplenishment211 === false">
              <el-form-item label="重新上传的销售合同PDF文件">
                <el-upload
                  class="upload-demo"
                  :data="qiniu"
                  :limit="1"
                  action="https://upload.qiniup.com"
                  :show-file-list="true"
                  :multiple="false"
                  :file-list="salesContractUrl11"
                  :before-upload="(file) => {return handleBeforeUpload311(file, index)}"
                  :on-success="(response, file, fileList) => { return handleOnSuccess311(response, file, fileList, index) }"
                  :on-remove="(file, fileList) => { return handleOnRemove311(file, fileList, index) }"
                >
                <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>
          </div>
        </div>
        </el-card>

        </el-form>
         <span slot="footer" class="dialog-footer">
          <el-button  @click="centerDialogVisible4 = false">取消</el-button>
          <el-button type="primary" @click="handlesend4()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 确认收货结束 -->


      <!-- 查看详情 ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！-->
      <el-dialog
        :title="title2"
        :visible.sync="centerDialogVisible3"
        width="50%"
        center>
        <el-form :model="form">

          
           <div class="disflexbtw">
            <el-form-item label="销售合同号" class="disflex">
              <div>{{ form.contractNumber }}</div>
            </el-form-item>
            <el-form-item label="商品名称" class="disflex">
               <div>{{ form.goodsName }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="型号" class="disflex">
              <div>{{ form.model }}</div>
            </el-form-item>
            <el-form-item label="规格" class="disflex">
              <div>{{ form.packWeight + form.goodsSpec }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="客户名称" class="disflex">
             <div>{{ form.companyName }}</div>
            </el-form-item>
            <el-form-item label="要求到货时间" class="disflex">
             <div>{{ formatime(form.arrivalTimeStart)+ ' 至 ' +formatime(form.arrivalTimeStart)  }}</div>
            </el-form-item>
          </div>

          <!-- <el-collapse  v-model="activeName"> -->
            <!-- <el-collapse-item  name="1"> -->
              <div class="disflexbtw">
                  <el-form-item label="下单联系人" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.name: '无'}}</div>
                  </el-form-item>
                  <el-form-item label="电话" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.phone: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="微信" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.weChat: '无' }}</div>
                  </el-form-item>
                  <el-form-item label="QQ" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.qq: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="邮箱" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.email: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售单价" class="disflex">
                  <div>{{ form.unitCost + form.currencyName }}</div>
                  </el-form-item>
                  <el-form-item label="下单时间" class="disflex">
                  <div>{{ formatime(form.placeOrderTime) }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="付款方式" class="disflex">
                  <div>{{ paymentType(form.paymentType) }}</div>
                  </el-form-item>
                  <el-form-item label="销售数量(净重)" class="disflex">
                  <div>{{ form.salesQuantity + '公斤' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售合同" class="disflex">
                  <el-button type="primary" size="mini" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
                  </el-form-item>
                  <el-form-item label="销售总价" class="disflex">
                  <div>{{ form.totalPrices + form.currencyName }}</div>
                  </el-form-item>
              </div>

              <div>
                <el-form-item label="销售数量(毛重)" class="disflex">
                  <div>{{ form.roughWeight }}公斤</div>
                </el-form-item>
              </div>

              <!-- 预售到此 -->

              <div v-if="orderStatus >= 2">
                <div  v-for="n in form.orderBatchVos" :key="n.key">
                  <div>
                      <el-form-item label="仓库地址" class="disflex">
                        <div>{{ n.locationName }}</div>
                      </el-form-item>
                  </div>

                  <!-- <div  v-for="nn in n.batchVos" :key="nn.key">
                    <div v-for="nnn in nn.orderDetailsDtos" :key="nnn.key"  class="disflexbtw">
                      <el-form-item label="批号" class="disflex">
                        <div>{{ nnn.lotNum }}</div>
                      </el-form-item>
                      <el-form-item label="数量" class="disflex">
                          <div>{{ nnn.salesVolume }}公斤</div>
                      </el-form-item>
                    </div>
                  </div> -->
                  

                   <div  v-for="nn in n.batchVos" :key="nn.key">
                      <div> 
                        <el-form-item label="入境货物检验检疫证明" class="disflex">
                          <el-button type="primary" size="mini" @click="downloadpdf(nn.healthCertificate)" >预览下载</el-button>
                        </el-form-item>
                      </div>
                      <div v-for="nnn in nn.orderDetailsDtos" :key="nnn.key"  class="disflexbtw">
                        <el-form-item label="批号" class="disflex">
                          <div>{{ nnn.lotNum }}</div>
                        </el-form-item>
                        <el-form-item label="数量" class="disflex">
                            <div>{{ nnn.salesVolume }}公斤</div>
                        </el-form-item>
                        <el-form-item label="COA" class="disflex">
                          <el-button type="primary" size="mini" @click="downloadpdf(nnn['coa'])" >预览下载</el-button>
                        </el-form-item>
                      </div>
                    </div>


                </div>
              </div>
              <!-- 待审核到此 -->
            <!-- </el-collapse-item> -->
          <!-- </el-collapse> -->

            <div v-if="orderStatus === 3">
              <el-form-item label="审核失败原因" class="disflex">
                <div>{{ form.remark }}</div>
              </el-form-item>
            </div>

          <!-- 已发货 -->

        <div v-if="orderStatus >= 5">
          <div class="disflexbtw">
            <el-form-item label="物流公司"  class="disflex">
              <div>{{ logisticsCompany.chineseName }}</div>
            </el-form-item>

            <el-form-item label="发货日期"  class="disflex red">
              <div>{{ takeContact.deliveryTime }}</div>
            </el-form-item>
          </div>


          <div class="disflexbtw">
             <el-form-item label="物流联系人" class="disflex">
              <div> {{ logisticsContact.name }} : {{ logisticsContact.phone }}</div>
            </el-form-item>

            
          </div>

          <div class="disflexbtw">
             <el-form-item label="到货地址" class="disflex">
              <div> {{ takeContact.consigneeAddress? takeContact.consigneeAddress: ''  }}</div>
            </el-form-item>

            <el-form-item label="收货联系人" class="disflex">
              <div> {{ takeContact.name }} : {{ takeContact.phone }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw" v-if="(roleCode === 'administrator' || roleCode === 'admin')">
            <el-form-item label="物流费用" class="dbgroup disflex" >
              <div>{{ takeContact.logisticsFees }}￥</div>
            </el-form-item>

             <el-form-item label="出库照片" class="disflex" >
               <el-button type="primary" size="mini" @click="downloadpdf(takeContact.shipmentFigureUrl)" >预览下载</el-button>
            </el-form-item>

            
          </div>

          <div class="disflexbtw">
            <el-form-item label="发货单" class="disflex">
               <el-button type="primary" size="mini" @click="downloadpdf(takeContact.dispatchBillUrl)" >预览下载</el-button>
            </el-form-item>

             <el-form-item label="仓库出货单(excel)" class="disflex" v-if="(roleCode === 'administrator' || roleCode === 'admin')">
               <el-button type="primary" size="mini" @click="downloadpdf(takeContact.warehouseExcelUrl)" >预览下载</el-button>
            </el-form-item>
          </div>
           <div class="disflexbtw">
              <el-form-item label="备注" class="disflex">
                  <div>{{ takeContact.remark }}</div>
              </el-form-item>
            </div>
          </div>
          <!-- 已发货到此 -->


          <div v-if="form.replenishmentOrderVos">
            <el-form-item label="补货跟单情况详情:">
            </el-form-item>

           <el-card class="box-card" v-for="r in form.replenishmentOrderVos" :key="r.key">
             <div class="disflexbtw">
                <el-form-item label="补货 销售合同号:" class="disflex">
                  <div>{{ r.contractNumber }}</div>
                </el-form-item>

                <el-form-item label="商品名称:" class="disflex">
                  <div>{{ r.goodsName }}</div>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="型号:" class="disflex">
                  <div>{{ r.mode }}</div>
                </el-form-item>

                <el-form-item label="规格:" class="disflex">
                  <div>{{ r.spec }}</div>
                </el-form-item>
              </div>

             
              <div>
                 <el-form-item label="仓库地址:" class="disflex">
                  <div>{{ cangkuAdress }}</div>
                </el-form-item>
              </div>

               <div v-for="nn in r.batchQuantity" :key="nn.key">
                <div v-for="nnn in nn" :key="nnn.key" class="disflexbtw">
                  <el-form-item label="批号" class="disflex">
                      <div>{{ splitStrkey(nnn) }}</div>
                  </el-form-item>
                  <el-form-item label="数量(净重)" class="disflex">
                      <div>{{ splitStrVal(nnn) }}公斤</div>
                  </el-form-item>
                </div>
              </div>

              <div class="disflexbtw">
                <el-form-item label="补货总数量:" class="disflex">
                  <div>{{ r.totalWeight }}</div>
                </el-form-item>
              </div>


              <div class="disflexbtw" v-if="orderStatus > 5">
                <el-form-item label="补货实收数量" class="disflex">
                    <div>{{ r.realQuantity }}</div>
                </el-form-item>
               
              </div>
            </el-card>
          </div>

            <div v-if="orderStatus > 5">
              <div class="disflexbtw">
                <el-form-item label="签收单" class="disflex">
                    <el-button type="primary" size="mini" @click="downloadpdf(form.receiptFormUrl)" >预览下载</el-button>
                </el-form-item>
                <el-form-item label="收货日期" class="disflex red">
                    <div>{{ formatime(form.signTime) }}</div>
                </el-form-item>
              </div>
              <div class="disflexbtw">
                <el-form-item label="客户实收(净重)" class="disflex">
                    <div>{{ form.realQuantity }}公斤</div>
                </el-form-item>
                <el-form-item label="签收照片" class="disflex">
                  <el-button type="primary" size="mini" @click="downloadpdf(form.receivingFigureUrl)" >预览下载</el-button>
                </el-form-item>
              </div>

             
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { 
  orderqueryList, qiniuupload, qiniugetDown, 
  orderaddOrder, goodsfindAll, goodsqueryById, findAll, crmcurrency, stockgoods, orderreviewOrder, 
  orderupdateOrder, orderdeleteOrder, orderqueryOrderDetails, 
  queryByCompanyId, contactfindAll, addressfindByCompanyId, 
  orderconsignment, orderconfirmReceipt, contactquery
} from '../../api'
import { mapGetters } from 'vuex'
import utils from '../../../public/utils'
import qs from 'qs'
import moment from 'moment'
export default {
  data () {
    return {
      activeName: '1',
      replenishmentOrderVos: '',
      centerDialogVisible2: false, //  发货弹窗
      centerDialogVisible3: false, //  详情弹窗
      centerDialogVisible4: false, //  详情弹窗
      title2: '',
      list: [],
      orderStatus: '',
      cangkuAdress: '', //  批号仓库地址
      damageVoList: {},
      ishowreplenishment: '', //  是否显示补货按钮
      ishowreplenishment2: '', //  是否显示补货按钮
      ishowreplenishment11: '', //  是否显示补货按钮
      ishowreplenishment211: '', //  是否显示补货按钮
      salesContractUrl11: [],
      Addresslist: [], //  收件地址
      centerDialogVisible: false,
      lotNumList: [],
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      uploadUrl: '', //  上传地址前缀
      salesContractUrl: [], //  合同文件
      dispatchBillUrl: [],
      receiptormUrl: [], //  签收单
      receivingFigureUrl: [],
      warehouseExcelUrl: [],
      shipmentFigureUrl: [],
      reviewOrder: {
        
      },
      logisticsCompany: {

      },
      logisticsContact: {

      },
      takeContact: {

      },
      status: '',
      currentpageIndex: 1,
      currentpageSize: 10,
      searchKey: '',
      roleCode: '',
      form: { //  新增初始化form
        // model: '',
        weekendWork: '1',
        remark: '',
        goodsSpec: '',
        packWeight: '',
        batchNumberIds: [],
        salesContractUrl: [], 
        dispatchBillUrl: [],
        warehouseExcelUrl: [],
        shipmentFigureUrl: [],
        receivingFigureUrl: [],
        salesQuantity: null,
        roughWeight: null,
        unitCost: null,
        damageVoList: {
          realQuantity: '',
          isReplenishment: '',
          salesContractUrl: '',
          receiptormUrl: '',
        }
      },
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑 2 编辑权限
      title: '', //  添加窗口标题
      isshow: false,
      currentStatus: '',
      statuslist: [
        {
          label: '所有',
          value: ''
        },
        {
          label: '预售',
          value: 1
        },
        {
          label: '等待审核',
          value: 2
        },
        {
          label: '审核失败',
          value: 3
        },
        {
          label: '待发货',
          value: 4
        },
        {
          label: '待收货',
          value: 5
        },
        {
          label: '完成',
          value: 6
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'contractNum',
      },
      totalprice: '', //  销售总价
      batchNumberIds: [],
      batchNumberIds2: [],
      defaultchecked: [],
      goodsList: [],
      companylist: [], //  采购商
      contactList: [], //  根据公司id查询的联系人列表
      contactList2: [],
      contactDetail: '', //  当前联系人信息
      currencyList: [],
      arr: [],
      currentPage: 1,
      total: 0,
      rules: {
        name: [
          { type: 'string', required: true, message: '请输入角色名', trigger: 'blur' },
        ],
        description: [
          { type: 'string', required: true, message: '请输入角色描述', trigger: 'blur' },
        ]
      },
      
    }
  },
  computed: {
    ...mapGetters([
      'getpaymentTypeList'
    ])
  },
  mounted () {
    this.getorderqueryList()
    let roleCode = sessionStorage.getItem('roleCode')
    console.log(roleCode)
    this.roleCode = roleCode
    this.getToken()
  },
  methods: {
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'crm-sea-transportation')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    handleChangePrice (val) { //  计算实收数量
      if (this.form.realQuantity < this.form.salesQuantity) {
        this.ishowreplenishment = true
      } else {
        this.ishowreplenishment = false
      }
    },
    handleChangePrice11 (val, index) {
      this.damageVoList.id = this.form.replenishmentOrderVos[index].id
      console.log(this.damageVoList.id)
      console.log(val, this.form.replenishmentOrderVos[index].totalWeight)
      if(val < this.form.replenishmentOrderVos[index].totalWeight) {
        this.ishowreplenishment11 = true
      } else {
        this.ishowreplenishment11 = false
      }
    },
    handleChangeshopping (val) { //  是否补货
      console.log(val)
      if (val == 1) {
        this.ishowreplenishment2 = true
      } else {
        this.ishowreplenishment2 = false
      }
    },
    handleChangeshopping11 (val) { //  是否补货
      console.log(val)
      if (val == 1) {
        this.ishowreplenishment211 = true
      } else {
        this.ishowreplenishment211 = false
      }
    },
    handlesend () { //  发货
      console.log(this.form, '发货')
      let f = this.form
      if( !f.weekendWork || !f.logisticsCompanyId || !f.logisticsContactsId || !f.deliveryTime
        || !f.consigneeAddressId || !f.logisticsFees || !f.dispatchBillUrl || !f.warehouseExcelUrl
        || !f.takeContarctsId) {
        return this.$message({
            message: '参数不完整！',
            type: 'error'
          })
        }
      this.form.deliveryTime = this.formatime(this.form.deliveryTime)
      let para = new URLSearchParams(this.form)
      orderconsignment(para).then(data => {
        console.log(data)
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryList()
          this.centerDialogVisible2 = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handlesend4 () {
      console.log(this.form, '确认收货')
      let f = this.form
      if( !f.signTime || !f.realQuantity || !f.receiptormUrl) {
        return this.$message({
            message: '参数不完整！星号必填！',
            type: 'error'
          })
        }
      this.form.signTime = this.formatime(this.form.signTime) //  确认收货时间
      console.log(this.form)
      let para = new URLSearchParams(this.form)
      var arr = []
      arr.push(this.damageVoList)
      console.log(arr)
      para.append('damageVoList', JSON.stringify(arr))
      orderconfirmReceipt(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryList()
          this.centerDialogVisible4 = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    paymentType (num) {
      switch (num) {
        case 1:
          return '货到付款'
        case 2:
          return '款到发货'
        case 3:
          return '预售部分发货'
      }
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let para = new URLSearchParams()
      para.append('baseUrl', w)
      qiniugetDown(para).then(data => {
        console.log(data.data)
        window.open(data.data)
      })
    },
    handleBeforeUpload3 (file) { //  上传之前
      this.qiniu.key = `salesContractUrl${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess3 (response, file, fileList) { //  上传成功之后
      this.form.salesContractUrl = this.uploadUrl + response.key
      this.salesContractUrl.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
      console.log(this.salesContractUrl)
    },
    handleOnRemove3 (file, fileList) {
      this.salesContractUrl = []
      this.form.salesContractUrl = ''
      console.log(file, fileList)
    },
    
    handleBeforeUpload311 (file, index) { //  上传之前
      this.qiniu.key = `salesContractUrl11${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess311 (response, file, fileList, index) { //  上传成功之后
      this.damageVoList.salesContractUrl = this.uploadUrl + response.key
      this.salesContractUrl11.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
      console.log(this.salesContractUrl11)
    },
    handleOnRemove311 (file, fileList, index) {
      this.salesContractUrl11 = []
      console.log(file, fileList)
    },

    handleBeforeUpload10 (file) { //  上传之前
      this.qiniu.key = `dispatchBillUrl${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess10 (response, file, fileList) { //  上传成功之后
      this.form.dispatchBillUrl = this.uploadUrl + response.key
      this.dispatchBillUrl.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove10 (file, fileList) {
      this.dispatchBillUrl = []
    },



    handleBeforeUpload11 (file) { //  上传之前
      this.qiniu.key = `warehouseExcelUrl${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess11 (response, file, fileList) { //  上传成功之后
      this.form.warehouseExcelUrl = this.uploadUrl + response.key
      this.warehouseExcelUrl.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove11 (file, fileList) {
      this.warehouseExcelUrl = []
    },

    handleBeforeUpload111 (file) { //  上传之前
      this.qiniu.key = `shipmentFigureUrl${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess111 (response, file, fileList) { //  上传成功之后
      this.form.shipmentFigureUrl = this.uploadUrl + response.key
      this.shipmentFigureUrl.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove111 (file, fileList) {
      this.shipmentFigureUrl = []
    },


    handleBeforeUpload21 (file) { //  上传之前
      this.qiniu.key = `receiptormUrl${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess21 (response, file, fileList) { //  上传成功之后
      this.form.receiptormUrl = this.uploadUrl + response.key
      this.receiptormUrl.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove21 (file, fileList) {
      this.receiptormUrl = []
    },

     handleBeforeUpload22 (file) { //  上传之前
      this.qiniu.key = `receivingFigureUrl${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess22 (response, file, fileList) { //  上传成功之后
      this.form.receivingFigureUrl = this.uploadUrl + response.key
      this.receivingFigureUrl.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove22 (file, fileList) {
      this.receivingFigureUrl = []
    },


    countPrice () {
      console.log(this.form.unitCost)
      console.log(this.form.salesQuantity)
      this.totalprice = this.form.unitCost * this.form.salesQuantity
      console.log(this.totalPrice)
    },
    handlechangeLotnum (val) {
      console.log(val)
    },
    handelCurrentChange (i) { // 分页
      this.currentpageIndex = i
      this.getorderqueryList()
    },
    handlePass (bol) {
      let para = new URLSearchParams()
      para.append('id', this.reviewOrder.id)
      para.append('isPasses', bol)
      para.append('remark', this.reviewOrder.remark)
      orderreviewOrder(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryList()
          this.centerDialogVisible = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    autogeneration () { //  自动生成合同号
      this.form.contractNumber = 'ly' + Math.round(new Date().getTime())
    },
    getcrmcurrency () { //  货币类型
      let para = {}
      crmcurrency(para).then(data => {
        console.log(data)
        this.currencyList = data.data.data
      })
    },
    handelchangecurrency (val) {
      this.getcrmcurrency()
    },
    handelchangecompany (val, type) { //  公司列表
      let para = {
        'status': 1,
        'typeId': type
      }
      this.contactList2 = []
      findAll(para).then(data => {
        console.log(data)
        this.companylist = data.data.data
         if (type === 1) {
          this.getqueryByCompanyId(val)
        }
        if (type === 6) {
          this.getqueryByCompanyId2(val)
        }
      })
      this.contactDetail = ''
     
    },
    handleChangeContact (val) {
      console.log(val)
      this.getcontactquery(val)
    },
    getcontactquery (val) { //  查询联系人
      let para = {
        id: val
      }
      contactquery(para).then(data => {
        console.log(data)
        this.contactDetail = data.data.data
      })
    },
    getqueryByCompanyId (val) { //  根据公司id查询联系人列表
      console.log(val)
      let para = {
        id: val
      }
      queryByCompanyId(para).then(data => {
        console.log(data)
        this.contactList = data.data.data
      })
    },
    getqueryByCompanyId2 (val) { //  根据公司id查询联系人列表
      let para = {
        id: val
      }
      queryByCompanyId(para).then(data => {
        console.log(data)
        this.contactList2 = data.data.data
      })
    },
    getaddressfindByCompanyId (row) { //  查询地址
      let para = {
        companyId: row
      }
      addressfindByCompanyId(para).then(data => {
        console.log(data)
        this.Addresslist = data.data.data
      })
    },
    getgoodsfindAll () { //  查询商品列表
      let para = {
        status: 1
      }
      goodsfindAll(para).then(data => {
        console.log(data)
        this.goodsList = data.data.data.rows
      })
    },
    handelchangegoods (val) { //  根据商品id填充规格
    console.log(1)
      let para = {
        id: val
      }
      goodsqueryById(para).then(data => {
        console.log(data)
        if (data.data.data.model) {
          this.form.model = data.data.data.model
        }
        if (data.data.data.packWeight) {
          this.form.packWeight = data.data.data.packWeight
        }
        if (data.data.data.goodsSpec) {
          this.form.goodsSpec = data.data.data.goodsSpec
        }
      })
      this.getstockgoods(val)
    },
    getstockgoods (val) { //  查询余量

      let para = new URLSearchParams()
      para.append('goodsId', val)
      stockgoods(para).then(data => {
        console.log(data)
        this.batchNumberIds = data.data
        // this.changeArray(data)
      })
    },
   
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      this.getgoodsfindAll() //  商品
      this.getcrmcurrency() //  币种
      // 
      this.isshow = false
      this.dispatchBillUrl = [] //
      this.warehouseExcelUrl = [] //  出货单
      this.receiptormUrl = [] //  清空签收单
      this.receivingFigureUrl = [] //  清空签收单
      this.salesContractUrl = [] //  销售合同
      this.shipmentFigureUrl = []
      console.log(row)
      if (ind === 1) { //  编辑
        this.form = row
        console.log(row)
        this.handelchangecompany(null, 1) //  采购商
        this.handelchangegoods(row.goodsId)
        this.form = {}
        this.title = '编辑销售订单'
        this.form = {
          salesQuantity: null,
          roughWeight: null,
          unitCost: null,
          model: '',
          companyId: '',
          packWeight: '',
          contractNumber: '',
          currencyCode: 1,
          batchNumberIds: []
        }
        this.batchNumberIds2= []
        
        this.sts = 1
        this.getorderqueryOrderDetails(row.id)
        console.log(this.form)

      } else if (ind === 0) { //  新增
        this.handelchangecompany(null, 1) //  采购商
        this.title = '创建子订单'
        this.form = {}
        this.form = {
          salesQuantity: null,
          roughWeight: null,
          unitCost: null,
          model: '',
          companyId: '',
          packWeight: '',
          contractNumber: '',
          currencyCode: 1,
          batchNumberIds: []
        }
        this.batchNumberIds= []
        this.sts = 0
        // this.form = this.$router.app._route.query.row
        console.log(this.$router.app._route.query.row)
        this.form.orderSummaryId = this.$router.app._route.query.row.id 
        this.form.companyId = this.$router.app._route.query.row.companyId 
        this.form.goodsId = this.$router.app._route.query.row.goodsId
        this.form.goodsName = this.$router.app._route.query.row.goodsName
        this.form.contractNumber = this.$router.app._route.query.row.contractNumber
        this.form.model = this.$router.app._route.query.row.model
        this.form.packWeight = this.$router.app._route.query.row.packWeight
        this.form.currencyCode = this.$router.app._route.query.row.currencyCode
        this.form.companyId = this.$router.app._route.query.row.companyId
        this.form.salesQuantity = this.$router.app._route.query.row.salesQuantity
        this.form.unitCost = this.$router.app._route.query.row.unitCost
        this.form.paymentType = this.$router.app._route.query.row.paymentType
        this.form.totalPrices = this.$router.app._route.query.row.totalPrices
        this.form.arrivalTimeStart = this.$router.app._route.query.row.arrivalTimeStart
        this.form.arrivalTimeEnd = this.$router.app._route.query.row.arrivalTimeEnd
        this.form.paymentType = this.$router.app._route.query.row.paymentType
        this.form.salesContractUrl = this.$router.app._route.query.row.salesContractUrl
        this.handelchangecompany(this.form.companyId, 1) //  采购商
        this.handelchangegoods(this.form.goodsId) //  商品库存
        // this.handelchangegoods(12) //  商品库存
        
      } else if (ind === 2) { //  查看
        // this.sts = 2
        this.centerDialogVisible = false
        this.centerDialogVisible3 = true
        this.title2 = '详情'
        console.log('当前订单状态:', row.orderStatus)
        this.orderStatus = row.orderStatus
        this.getorderqueryOrderDetails(row.id)
        // this.isshow = true
      } else if (ind === 3) { //  审核
        this.sts = 3
        // this.form = row
        this.title = '审核'
        this.getorderqueryOrderDetails(row.id)
        this.reviewOrder.id = row.id
        this.isshow = true
      } else if (ind === 4) {
        this.centerDialogVisible = false
        setTimeout(() => {
         this.centerDialogVisible2 = true
        }, 10)
        this.title2 = '发货'
        //  发货单, 仓库出货情况  
        this.dispatchBillUrl = []
        this.warehouseExcelUrl = []
        this.shipmentFigureUrl = []
        this.form.shipmentFigureUrl = []
        this.form.warehouseExcelUrl = ''
        this.form.dispatchBillUrl = ''
        this.getaddressfindByCompanyId(row.companyId)
        // this.getqueryByCompanyId2(row.companyId)
        this.getorderqueryOrderDetails(row.id)
        this.companylist = []
        this.handelchangecompany(null, 6) //  物流公司
        
      }  else if (ind === 5) { //  确认收货
        this.centerDialogVisible = false
        this.centerDialogVisible4 = true
        this.receiptormUrl = []
        this.form.receiptormUrl = ''
         this.receivingFigureUrl = []
        this.form.receivingFigureUrl = ''
        this.salesContractUrl = []
        this.form.salesContractUrl = ''
        this.ishowreplenishment = false
        this.ishowreplenishment2 = true
        this.salesContractUrl11 = []
        this.title2 = '确认收货'
        this.form.damageVoList = {
          realQuantity: '',
          isReplenishment: '',
          salesContractUrl: '',
          receiptormUrl: '',
        }
        this.getorderqueryOrderDetails(row.id)
        
      }
    },
    getorderqueryOrderDetails (id) { //  查看订单详情
      let para = new URLSearchParams()
      para.append('id', id)
      orderqueryOrderDetails(para).then(data => {
        console.log(data)
        this.form  = data.data
        console.log(this.form)
        if(this.form.placeOrderVo) {
          console.log(this.form.placeOrderVo)
          this.logisticsCompany.chineseName = this.form.placeOrderVo.logisticsCompany.chineseName //  物流公司
          this.takeContact.deliveryTime = this.formatime(this.form.placeOrderVo.deliveryTime) //  发货时间
          this.logisticsContact.name = this.form.placeOrderVo.logisticsContact.name //  物流联系人
          this.logisticsContact.phone = this.form.placeOrderVo.logisticsContact.phone //  物流联系人电话
          this.takeContact.consigneeAddress = this.form.placeOrderVo.consigneeAddress //  收件地址
          this.takeContact.name = this.form.placeOrderVo.takeContact.name //  收件联系人
          this.takeContact.phone = this.form.placeOrderVo.takeContact.phone //  收件联系人电话
          this.takeContact.logisticsFees = this.form.placeOrderVo.logisticsFees //  物流费用
          this.takeContact.dispatchBillUrl = this.form.placeOrderVo.dispatchBillUrl //  发货单
          this.takeContact.warehouseExcelUrl = this.form.placeOrderVo.warehouseExcelUrl //  仓库出货情况
          this.takeContact.weekendWork = this.form.placeOrderVo.weekendWork //  周末是否出货
          this.takeContact.shipmentFigureUrl = this.form.placeOrderVo.shipmentFigureUrl
          this.takeContact.remark = this.form.placeOrderVo.remark
        }
        if (this.form.replenishmentOrderVos) {
          console.log(this.form.replenishmentOrderVos)
          this.replenishmentOrderVos = this.form.replenishmentOrderVos
          for (let o in this.form.replenishmentOrderVos[0].batchQuantity) {
            this.cangkuAdress = o
          }
          // let cangkuAdress = this.form.replenishmentOrderVos.batchQuantity
          // for(let obj in cangkuAdress) {
          //   console.log(cangkuAdress[obj])
          // }
          // console.log(this.form)
          // let replist = this.form.replenishmentOrderVos
          // let bag = {}
          // for (let i = 0; i<replist.length; i++) {
          //   console.log(replist[i])
          //   for (let a in replist[i].batchQuantity) {
          //     console.log(replist[i].batchQuantity[a])
          //     for (let b in replist[i].batchQuantity[a]) {
          //       bag.key = b
          //       bag.value = replist[i].batchQuantity[a][b]
          //       console.log(bag)
          //       replist[i].batchQuantity = bag
          //     }
          //   }
          // }
        }
        // if (this.sts === 1) {
        //   this.form['batchNumberIds'] = []
        // }
        //  查询公司
        this.getqueryByCompanyId(this.form.companyId)
        //  查询联系人
        this.getcontactquery(this.form.contactsId)
        //  销售合同
      })
    },
    handlesuccess (sts) { //  提交修改信息
      // if (!this.form.salesContractUrl || this.form.salesContractUrl === '') {
      //   this.$message({
      //     message: '销售合同不能为空',
      //     type: 'error'
      //   })
      // }
      if (sts === 0) {
        this.form.arrivalTimeStart = this.formatime(this.form.arrivalTimeStart)
        this.form.arrivalTimeEnd = this.formatime(this.form.arrivalTimeEnd)
        this.form.placeOrderTime = this.formatime(this.form.placeOrderTime)
        let para = new URLSearchParams(this.form)
        orderaddOrder(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getorderqueryList()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else if (sts === 1){
        //  修改权限
        this.isshow = false
        if (this.form.batchNumberIds === undefined) {
          this.form.batchNumberIds = ''
        }
        this.form.batchNumberIds = this.batchNumberIds2
        this.form.arrivalTimeStart = this.formatime(this.form.arrivalTimeStart)
        this.form.arrivalTimeEnd = this.formatime(this.form.arrivalTimeEnd)
        this.form.placeOrderTime = this.formatime(this.form.placeOrderTime)
        let para = new URLSearchParams(this.form)
        orderupdateOrder(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getorderqueryList()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })

      } else if (sts === 2) {
        this.centerDialogVisible = false
      }
    },
    handleDelete (ind, row) { //  删除
      let para = new URLSearchParams()
      para.append('id', row.id)
      orderdeleteOrder(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryList()
          this.centerDialogVisible = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    getorderqueryList () { //  查询销售订单
      
      let obj = {
        orderStatus: this.currentStatus,
        pageIndex: this.currentpageIndex,
        pageSize: this.currentpageSize,
        searchKey: this.searchKey,
        orderSummaryId: this.$router.app._route.query.row.id
      }
      let params = new URLSearchParams(obj)
      orderqueryList(params).then(data => {
        console.log(data)
        if (data.data.rows) {
          this.list = data.data.rows
        } else {
          this.list = []
        }
        this.total = data.data.total
      })
    },
    handleChangeOrderStatus (val) {
      console.log(val)
      this.currentpageIndex = 1
      
      this.getorderqueryList()
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    splitStrkey (val) {
      let a = val.split(':')
      return a[0]
    },
    splitStrVal (val) {
      let a = val.split(':')
      return a[1]
    },
    resetstatus (s) {
      switch (s) {
        case 1:
          return "预售"
          break
        case 2:
          return "等待审核"
          break
        case 3:
          return "审核失败"
          break
        case 4:
          return "待发货"
          break
        case 5:
          return "待收货"
          break
        case 6:
          return "待开票"
          break
        case 7:
          return "等待补货"
          break
        case 8:
          return "待收款"
          break
        case 9:
          return "部分收款"
          break
        case 10:
          return "已完成"
          break
      }
    }
  },
}
</script>
<style lang="stylus">
.red label{
  color red
}
.disflex {
  display flex
}
.box-card {
  width 100%
}
.disflexbtw {
  display flex
  justify-content space-between
}
#sellorder 
  .el-input__inner
    width 180px
  .dbgroup
    .el-input-group
      display flex
    .el-input-group__append
      width 50px
      line-height: 2em;
      padding-top: 5px;
    .el-input__suffix
      right 95px
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
.choosetime
  .el-form-item__content
    display flex
</style>
